import * as React from "react";
const SvgGlass = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { style: {
  fill: "none"
}, d: "M19.0002 19L14.7002 14.7M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z", stroke: "currentColor", strokeWidth: 1.33, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgGlass;
